/**
 * PhotoPrint mixin
 *
 * Добавляет логику для печати фото
 *
 */

export const PHOTO_PRINT_STATUS = Object.freeze({
  ERROR: 'ERROR',
  IDLE: 'IDLE',
  NOT_CONNECTED: 'NOT_CONNECTED',
  IN_PROCESS: 'IN_PROCESS',
});

export default {
  created() {
    this.initPhotoPrintActions();
  },
  methods: {
    async startPhotoPrint(source) {
      try {
        this.onStartPhotoPrint?.(); // eslint-disable-line
        await this.$robot.printPhotoService.print(source);
      } catch {
        this.checkPhotoPrintStatus();
      }
    },
    async checkPhotoPrintStatus() {
      try {
        const status = await this.$robot.printPhotoService.status();
        if (status === PHOTO_PRINT_STATUS.ERROR) {
          throw new Error();
        }
      } catch {
        this.onPhotoPrintError();
      }
    },
    sendPhotoPrintFinish() {
      return this.onFinishPhotoPrint?.();
    },
    disablePhotoPrint() {
      return this.onNoPrinter?.();
    },
    initPhotoPrintActions() {
      const robotActions = [
        this.$robot.printPhotoService.onNoPrinter(this.disablePhotoPrint),
        this.$robot.printPhotoService.onFinish(this.sendPhotoPrintFinish),
        this.$robot.printPhotoService.onError(this.checkPhotoPrintStatus),
      ];

      this.$robot.printPhotoService.status();

      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
      });
    },
  },
};
